import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b6dc897a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "software-name-wrapper" }
const _hoisted_2 = { class: "software-name" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "install-rate-cell"
}
const _hoisted_5 = { class: "install-rate-text" }
const _hoisted_6 = {
  key: 1,
  class: "install-rate-text"
}

import { reactive, ref, PropType, onMounted, nextTick, computed, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'

import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import {
  SoftwareManageService,
  SoftwareInfo,
  QueryParams as SoftwareQueryParams,
} from '../software-view/software-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  FormSize,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { ServicePermissionService, PermissionFe } from '@/services/service-permission.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'software-list-top10',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  hasPermission: {
    type: Boolean,
    default: true
  },
  groupId: {
    type: Number,
    default: -1
  },
  /** 由饼图传入时预选的软件类型（对应接口 soft_type） */
  presetSoftType: {
    type: Number as PropType<number | undefined>,
    default: '-1'
  }
},
  emits: ['viewAll', 'detail'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emits = __emit

/** 接口下发的安装率 0–100，用于进度条 */
function installRatePercent (rate: number | undefined): number {
  const n = Number(rate ?? 0)
  if (Number.isNaN(n)) return 0
  return Math.min(100, Math.max(0, Number(n.toFixed(1))))
}

const injector = useReflectiveInjector()
const softwareService = injector.get(SoftwareManageService)
const servicePermissionService = injector.get(ServicePermissionService)
const dataApi = softwareService.getSoftwareList.bind(softwareService)
const hasPermission = props.hasPermission || servicePermissionService.getHasPermission(PermissionFe.softmgr)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const total = computed(() => tableRef.value?.total || 0)

const queryParams = reactive<SoftwareQueryParams & { soft_type?: number }>({
  key_word: '',
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  sort: 'install_count',
  asc: false,
  group_id: props.groupId,
  soft_type: props.presetSoftType
})
const softGroupObj = ref<Record<number, string>>({})
const filterFormColumns = reactive<ObjectFormItem<typeof queryParams, 'soft_type'>>({
  soft_type: {
    prop: 'soft_type',
    label: t('softwareManage.softType'),
    type: FormType.Select,
    colOpt: { style: 'width: 150px; flex: 0 0 auto' },
    hiddenAllLabel: true,
    outSearchFiledFlag: true,
    dictData: [
      { label: t('softwareManage.softTypeAll'), value: '-1' }
    ],
    events:{
      change:handleQuery
    }
  }
})

async function loadSoftGroupDict () {
  try {
    const res = await softwareService.getSoftGroup()
    const list = res?.list || []
    filterFormColumns.soft_type.dictData = [
      { label: t('softwareManage.softTypeAll'), value: '-1' },
      ...list.map((g) => ({ label: g.group_name, value: g.group_id })),
      { label: t('softwareManage.softTypeOther'), value: 0 },
    ]
    softGroupObj.value = filterFormColumns.soft_type.dictData.reduce((acc, item) => {
      acc[item.value] = item.label
      return acc
    }, {})
  } catch {
    filterFormColumns.soft_type.dictData = [
      { label: t('softwareManage.softTypeAll'), value: '-1' },
      { label: t('softwareManage.softTypeOther'), value: 0 },
    ]
  }
}

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: t('portManage.operation'), width: 100, fixed: 'right' },
    actionButtons: () => [
      { name: t('portManage.detail'), type: 'detail', opt: { size: FormSize.Small, text: true, type: 'text' } }
    ]
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
    path: 'list',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: 'soft_id',
    selection: false,
    showTip: false,
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      { prop: 'name', label: t('softwareManage.softwareName'), columnOpt: { minWidth: 200 } },
      { prop: 'soft_group_id', label: t('softwareManage.softType'), columnOpt: { minWidth: 180 },formatter: (row: SoftwareInfo,val: number) => softGroupObj.value[val] || '--' },
      { prop: 'version_range', label: t('softwareManage.installedVersionRange'), columnOpt: { minWidth: 180 } },
      { prop: 'install_count', label: t('softwareManage.installedTerminal'), columnOpt: { minWidth: 120 }, sortable: 'custom' },
      { prop: 'install_rate', label: t('softwareManage.installRate'), columnOpt: { minWidth: 180 } }
    ],
    totalPath: 'total',
    tableActOpt: tableActOpt.value
  }
})

async function handleSearch(value: string) {
  await nextTick()
  queryParams.key_word = value
  queryParams.page = 1
  void refreshList()
}

async function handleQuery(form: any) {
  Object.assign(queryParams, form)
  queryParams.page = 1
  await refreshList()
}

function handleReset() {
  queryParams.key_word = ''
  queryParams.soft_type = undefined
  queryParams.group_id = props.groupId
  queryParams.page = 1
  void refreshList()
}

watch(() => props.groupId, (v) => {
  queryParams.group_id = v
  queryParams.page = 1
  void refreshList()
})

watch(() => props.presetSoftType, (v) => {
  queryParams.soft_type = v
  queryParams.page = 1
  void refreshList()
})

function handleAction({ type, rowItem }: { type: string; rowItem: SoftwareInfo }) {
  if (type === 'detail') {
    handleDetail(rowItem)
  }
}

function handleDetail(item: SoftwareInfo) {
  emits('detail', item)
}

function download(type: 0 | 1) {
  softwareService.download(type, queryParams, t('softwareManage.exportSoftwareView'))
}

watch(locale, () => {
  loadSoftGroupDict()
})

onMounted(async () => {
  if (!hasPermission) return
  await loadSoftGroupDict()
  await refreshList()
})

__expose({
  tableRef,
  getList: () => void refreshList(),
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    tableActOpt: tableActOpt.value,
    firstLoading: false,
    "has-permission": _unref(hasPermission),
    api: _unref(dataApi),
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
    onHandleAction: handleAction
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
        "form-columns": filterFormColumns,
        disabled: !_unref(hasPermission),
        "show-search": true,
        "search-placeholder": _ctx.$t('softwareManage.searchPlaceholderSoft'),
        "popover-threshold": 0,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        actions: _withCtx(() => [
          _createVNode(ExportDropdown, {
            "has-permission": _unref(hasPermission),
            onExport: download
          }, null, 8, ["has-permission"]),
          (props.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                disabled: !_unref(hasPermission),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
    ]),
    name: _withCtx(({ row }: { row?: SoftwareInfo & { soft_group_name?: string } }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(row?.name), 1),
        (row?.soft_group_name)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              size: "small",
              type: "success",
              class: "software-tag"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.soft_group_name), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ])
    ]),
    version_range: _withCtx(({ row }: { row?: SoftwareInfo }) => [
      _createElementVNode("span", null, _toDisplayString(row.min_version || '0') + " - " + _toDisplayString(row.max_version || 0), 1)
    ]),
    install_count: _withCtx(({ row }: { row?: SoftwareInfo }) => [
      row
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            disabled: !row.install_count,
            type: "text",
            onClick: ($event: any) => (handleDetail(row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(row.install_count), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "0"))
    ]),
    install_rate: _withCtx(({ row }: { row?: SoftwareInfo }) => [
      row
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_progress, {
              class: "install-rate-progress",
              percentage: installRatePercent(row.install_rate),
              "stroke-width": 8,
              "show-text": false
            }, null, 8, ["percentage"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(row.install_rate) + "%", 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, "0%"))
    ]),
    _: 1
  }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue"]))
}
}

})